import { Link, NavLink, useLocation } from "react-router-dom";
import SideBarLink from "./SideBarLink";
import {
  Dashboardsvg,
  Enquirysvg,
  Userssvg,
  Templatesvg,
  Adminsvg,
  Watersvg,
  Catchsvg,
  Rulessvg,
  Trophy,
  Archivesvg,
  Newslettersvg,
  QuickMessagesvg,
} from "../SvgFile/Index";
import { useEffect, useMemo, useState } from "react";
import Logout from "../Component/Pages/Auth/Logout";

const MOBILE_BREAKPOINT = 992; // keep in sync with the CSS breakpoint

const ADMIN_LINKS = [
  { url: "/admin/member", roleName: "Member Management", icon: <Userssvg /> },
  {
    url: "/admin/quick-message",
    roleName: "Quick Messages",
    icon: <QuickMessagesvg />,
  },
  { url: "/admin/enquiries", roleName: "GGC Enquiries", icon: <Enquirysvg /> },
  {
    url: "/admin/templates",
    roleName: "Manage Templates",
    icon: <Templatesvg />,
  },
  {
    url: "/admin/fishery-management",
    roleName: "Fishery Management",
    icon: <Watersvg />,
  },
  { url: "/admin/catch-return", roleName: "Catch Returns", icon: <Catchsvg /> },
  {
    url: "/admin/rules-and-regulations",
    roleName: "Rules And Regulations",
    icon: <Rulessvg />,
  },
  {
    url: "/admin/incident-reports",
    roleName: "Incident Reports",
    icon: <Rulessvg />,
  },
  {
    url: "/admin/annual-Competitions",
    roleName: "Competitions, Dinners & Events",
    icon: <Trophy />,
  },
  {
    url: "/admin/club-archive",
    roleName: "Club Archive",
    icon: <Archivesvg />,
  },
  {
    url: "/admin/news-letter",
    roleName: "News Letter",
    icon: <Newslettersvg />,
  },
  {
    url: "/admin/terms-and-conditions",
    roleName: "Terms and Conditions",
    icon: <Newslettersvg />,
  },
  { url: "/admin/pages", roleName: "Pages", icon: <Newslettersvg /> },
];

const MASTER_ADMIN_LINK = {
  url: "/admin/subadmin",
  roleName: "Manage Admin Users",
  icon: <Adminsvg />,
};

const FALLBACK_PHOTO = "/image/person.svg";

function getStoredUser() {
  try {
    return JSON.parse(localStorage.getItem("userData")) || null;
  } catch {
    return null;
  }
}

function setSidebarOpen(value) {
  localStorage.setItem("sidebarOpen", String(value));
  window.dispatchEvent(new Event("storage")); // same event the header and layout use
}

export default function Sidebar() {
  const [open, setOpen] = useState(false);
  const [user] = useState(getStoredUser);
  const location = useLocation();

  const links = useMemo(
    () =>
      user?.role === "master_admin"
        ? [MASTER_ADMIN_LINK, ...ADMIN_LINKS]
        : ADMIN_LINKS,
    [user?.role],
  );

  const roleLabel = user?.role
    ? user.role.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
    : "";

  const handleClose = () => setOpen(false);

  // On mobile, close the sidebar after navigating to a new page
  useEffect(() => {
    if (window.innerWidth < MOBILE_BREAKPOINT) {
      setSidebarOpen(false);
    }
  }, [location.pathname]);

  return (
    <>
      <div className="intersight_menu">
        <button
          type="button"
          className="mobile_cross w-100 text-end border-0 bg-transparent"
          aria-label="Close sidebar"
          onClick={() => setSidebarOpen(false)}
        >
          <svg
            width={24}
            height={24}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path
              fill="#000000"
              d="M15.71,8.29a1,1,0,0,0-1.42,0L12,10.59,9.71,8.29A1,1,0,0,0,8.29,9.71L10.59,12l-2.3,2.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l2.29,2.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L13.41,12l2.3-2.29A1,1,0,0,0,15.71,8.29Zm3.36-3.36A10,10,0,1,0,4.93,19.07,10,10,0,1,0,19.07,4.93ZM17.66,17.66A8,8,0,1,1,20,12,7.95,7.95,0,0,1,17.66,17.66Z"
            />
          </svg>
        </button>

        <div className="top_menu">
          <div className="brand">
            <button
              className="border-0 w-100 d-flex align-items-center"
              type="button"
              // data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="d-flex align-items-center justify-content-center">
                <img src="/image/fish.svg" alt="" className="img-fluid" />
              </span>
              <div className="brand_dashboard">
                <span>Glendale Grayling Club</span>
                <h6>Est. 1838</h6>
              </div>
            </button>
          </div>

          <div className="intersight_home">
            <div className="menu_div user_menu">
              <ul>
                <li>
                  <NavLink
                    to="/admin/dashboard"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <span>
                      <Dashboardsvg />
                    </span>
                    Dashboard
                  </NavLink>
                </li>

                <li className="without_label">Workspace</li>
              </ul>

              <ul className="menu_scrollbar">
                {links.map((item) => (
                  <SideBarLink
                    key={item.url}
                    href={item.url}
                    name={item.roleName}
                    icon={item.icon}
                  />
                ))}
              </ul>

              <div className="bottom_menu">
                <div className="user_person">
                  <div className="dropdown">
                    <button
                      className="dropdown-toggle border-0 w-100 d-flex align-items-center p-0"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <span className="d-flex align-items-center justify-content-center person_icon">
                        <img
                          src={user?.picture?.url || FALLBACK_PHOTO}
                          alt=""
                          loading="lazy"
                          className="img-fluid"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = FALLBACK_PHOTO;
                          }}
                        />
                      </span>
                      <span className="person_name">
                        {user?.firstName} {user?.surname}
                        <span className="d-block">{roleLabel}&nbsp;</span>
                      </span>
                    </button>

                    <ul className="dropdown-menu w-100">
                      <li>
                        <Link className="dropdown-item" to="/admin/profile">
                          Profile Info
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/admin/chnage-password"
                        >
                          Reset Password
                        </Link>
                      </li>
                      <li>
                        <button
                          type="button"
                          className="dropdown-item"
                          onClick={() => setOpen(true)}
                        >
                          Logout
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Logout open={open} handleClose={handleClose} />
    </>
  );
}
